import collapse, { destroy as destroyCollapse } from '@/vjs/collapse';
import fileUpload, { destroy as destroyFileUpload } from '@/vjs/file-upload';
import multiSelect, { destroy as destroyMultiSelect } from '@/vjs/multi-select';
import orcidFilter, { destroy as destroyOrcidFilter } from '@/vjs/orcid-filter';
import tabs, { destroy as destroyTabs } from '@/vjs/tabs';
import scrollbar, { destroy as destroyScrollbars } from '@/vjs/scrollbar';

export default {
    $create() {
        collapse();
        fileUpload();
        multiSelect();
        orcidFilter();
        tabs();
        scrollbar();
    },
    $destroy() {
        destroyCollapse();
        destroyFileUpload();
        destroyMultiSelect();
        destroyOrcidFilter();
        destroyTabs();
        destroyScrollbars();
    },
    $reinit() {
        this.$destroy();
        this.$create();
    }
};
